module.exports = __webpack_public_path__ + "img/numbers.4d729244.svg";